import React from 'react';
import { Link } from 'react-router-dom';
import { useLogin } from '../hooks/useLogin';

function Login() {
  const { email, setEmail, password, setPassword, error, isLoggingIn, handleLogin } = useLogin();

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-5 col-xl-4">
          <div className="card mt-5 shadow-sm">
            <div className="card-body p-4">
              <h2 className="card-title text-center mb-4">Sign In</h2>
              {error && <div className="alert alert-danger" role="alert">{error}</div>}
              <form onSubmit={handleLogin}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoggingIn}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoggingIn}
                  />
                </div>
                <div className="d-grid mt-4">
                    <button type="submit" className="btn btn-primary" disabled={isLoggingIn}>
                        {isLoggingIn ? 'Logging In...' : 'Login'}
                    </button>
                </div>
              </form>

              <div className="text-center mt-3">
                <Link to="/forgot-password">Forgot Password?</Link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
